var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryFeeSideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7263_3424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7384 21.0512C11.7384 19.7874 10.714 18.7629 9.45038 18.7629C8.18657 18.7629 7.16211 19.7874 7.16211 21.051C7.16211 22.3148 8.18657 23.3393 9.45038 23.3393C10.7133 23.3379 11.7371 22.3143 11.7384 21.0512ZM7.9737 21.0512C7.9737 20.2355 8.63471 19.5745 9.45038 19.5745C10.2658 19.5745 10.9268 20.2355 10.9268 21.051C10.9268 21.8667 10.2658 22.5277 9.45038 22.5277C8.63516 22.5268 7.97461 21.8662 7.9737 21.0512Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9233 23.3393C19.1871 23.3395 20.2116 22.315 20.2116 21.0512C20.2118 19.7874 19.1873 18.7629 17.9235 18.7629C16.6597 18.7629 15.6353 19.7874 15.6353 21.0512C15.6368 22.3141 16.6602 23.3377 17.9233 23.3393ZM17.9233 19.5745C18.7387 19.5745 19.4 20.2355 19.4 21.051C19.4002 21.8664 18.739 22.5277 17.9235 22.5277C17.1081 22.5277 16.4468 21.8667 16.4468 21.0512C16.4478 20.2362 17.1083 19.5757 17.9233 19.5745Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.405795 1.4493H2.8811C3.69563 1.44613 4.39015 2.0392 4.51424 2.84445L6.4737 15.2219C6.6587 16.4221 7.69403 17.3063 8.90847 17.3016H21.0203C21.2442 17.3016 21.4261 17.1197 21.4261 16.8958C21.4261 16.6716 21.2442 16.49 21.0203 16.49H8.90847C8.09393 16.4932 7.39942 15.8999 7.27532 15.0948L6.94222 12.9905H19.3468C20.3971 12.99 21.3319 12.3247 21.6761 11.3326L23.9775 4.69046C24.0207 4.56636 24.001 4.42913 23.9249 4.32202C23.8486 4.21514 23.7254 4.15151 23.5941 4.15151H5.54277L5.31587 2.71741C5.13086 1.51724 4.09554 0.632959 2.8811 0.637714H0.405795C0.181611 0.637714 0 0.819552 0 1.04351C0 1.26769 0.181611 1.4493 0.405795 1.4493ZM23.0239 4.96333L20.9093 11.0668C20.6783 11.7323 20.0513 12.1786 19.3468 12.1789H6.8136L5.67116 4.9631L23.0239 4.96333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7263_3424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryFeeSideMenu);
export default __webpack_public_path__ + "static/media/DeliveryFeeSideMenu.0fb55c79f1f3a1456e353795f6d44b38.svg";
export { ForwardRef as ReactComponent };